import { render, staticRenderFns } from "./ttshop_store.vue?vue&type=template&id=3405219a&scoped=true&"
import script from "./ttshop_store.vue?vue&type=script&lang=js&"
export * from "./ttshop_store.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_store.vue?vue&type=style&index=0&id=3405219a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3405219a",
  null
  
)

export default component.exports